import { Button } from 'antd';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 10px;

  span {
    flex-shrink: 0;
  }

  h5 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const StyledLogoutButton = styled(Button)`
  position: absolute;
  border: none;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  right: -100px;
  top: -65px;

  &.ant-btn.ant-btn-default,
  &.ant-btn.ant-btn-dashed {
    background-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.title_85};
  }
`;
